import type { Theme, Components } from '@mui/material/styles';

export function getComponentOverrides(theme: Theme): { components: Components<Theme> } {
    return {
        components: {
            MuiCssBaseline: {
                styleOverrides: {
                    'html, body, #root': {
                        height: '100%',
                        margin: 0,
                        padding: 0,
                    },
                    body: {
                        backgroundColor: theme.palette.background.default,
                        color: theme.palette.text.primary,
                    },
                    // Scrollbar styling
                    '*::-webkit-scrollbar': {
                        width: 8,
                        height: 8,
                    },
                    '*::-webkit-scrollbar-track': {
                        background: 'transparent',
                    },
                    '*::-webkit-scrollbar-thumb': {
                        backgroundColor: theme.palette.divider,
                        borderRadius: 4,
                    },
                },
            },
            // TODO: add component overrides as the design system evolves
        },
    };
}
